import * as amplitude from "@amplitude/analytics-browser";
import { MenuItem, useDisclosure } from "@chakra-ui/react";
import { SavedView } from "src/hooks/useSavedViews";
import { ShareSavedViewDialog } from "../Dialogs/ShareSavedViewDialog";
interface ShareSavedViewProps {
  savedView: SavedView;
  formTemplateName: string;
}

export const ShareSavedView = ({
  savedView,
  formTemplateName,
}: ShareSavedViewProps) => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  return (
    <>
      <MenuItem
        key={`share-${savedView.id}`}
        onClick={(e) => {
          e.stopPropagation();
          amplitude.track("Clicked share view", {
            form_name: formTemplateName,
          });
          onOpen();
        }}
      >
        Share
      </MenuItem>
      <ShareSavedViewDialog
        isOpen={isOpen}
        onClose={onClose}
        savedViewId={savedView.id}
      />
    </>
  );
};
